module.exports = require("@material-ui/icons/AddBoxOutlined");